import { useContext } from 'react';
import { AddPasswordPanelContext } from './context';

export default function useOpenAddPasswordPanel() {
  const panel = useContext(AddPasswordPanelContext);
  if (!panel) throw new Error('useShowAddPasswordPanel must be used within an AddPasswordPanelProvider');

  return panel.open;
}
